module.exports = __webpack_public_path__ + "img/222.41e449f6.jpg";